import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import useDocDownload from "../../hooks/useDocDownload";
import { useDispatch, useSelector } from "react-redux";
import { deleteBackgroundChecks, getBackgroundChecks, getBcDeleteStatus, loadBackgroundChecks } from "../../store/candidate";
import AddBcChecks from "../../../components/OMCRegistry/AddBcChecks";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import config from "../../../config.json";
import HttpService from "../../../services/HttpService";

const BcChecks = (props) => {

    const { subProccessTask, candidateObj } = props;

    console.log(props);

    const [bcCheckShowHide, setBcCheckShowHide] = useState(false);
    const [backgroundChecks, setBackgroundChecks] = useState([]);
    const [bcObject, setBcObject] = useState(null);
    const [bcType, setBcType] = useState(null);

    const backgroundChecksSelector = useSelector(getBackgroundChecks);
    const bcDeleteStatusSelector = useSelector(getBcDeleteStatus);

    const [handleDownloadFile] = useDocDownload();

    const dispatch = useDispatch();

    useEffect(() => {
        if (subProccessTask?.applicantId > 0) {
            dispatch(loadBackgroundChecks(subProccessTask.applicantId));
        }
    }, [subProccessTask]);

    useEffect(() => {
        setBackgroundChecks(backgroundChecksSelector);
    }, [backgroundChecksSelector])

    const handleBcCheckShowHide = (obj, type) => {
        if (obj === "save") {
            if (subProccessTask?.applicantId > 0)
                dispatch(loadBackgroundChecks(subProccessTask.applicantId));

            setBcType(null);
            setBcObject(null);
            setBcCheckShowHide(false);

        } else {
            setBcCheckShowHide(!bcCheckShowHide);
            setBcObject(obj);
            setBcType(type);
        }
    }

    const handleDeleteTimeSheetDoc = async (id) => {
        const result = await getConfirmAlert("Warning", "Are you sure you want to delete this Document?", "warning");
        if (result.isConfirmed) {
            const response = await HttpService.get(
                config.DeleteBcDoc + id
            );
            if (response) {
                getAlert("", "Deleted Successfully", "success");
            }
            if (subProccessTask?.applicantId > 0) {
                dispatch(loadBackgroundChecks(subProccessTask.applicantId));
            }
        }
    }

    const handleDeleteBcDoc = () => {

    }

    const handleDeleteBcChecks = async (id) => {
        const result = await getConfirmAlert("", "Are you sure you want to Delete this Background Check?", "warning");
        if (result.isConfirmed) {
            dispatch(deleteBackgroundChecks(id))
        }
    }

    useEffect(() => {
        if (bcDeleteStatusSelector) {
            getAlert("", "Deleted Successfully", "success");

            if (subProccessTask?.applicantId > 0)
                dispatch(loadBackgroundChecks(subProccessTask.applicantId));
        }
    }, [bcDeleteStatusSelector])

    const handleBcLoad = () => {
        if (subProccessTask?.applicantId > 0)
            dispatch(loadBackgroundChecks(subProccessTask.applicantId));
    }

    return <>
        <div className="col-md-12 text-right">
            <button
                className="btn btn-sm btn-outline-default"
                onClick={() => handleBcCheckShowHide(null, "new")}
            >
                Add New
            </button>
        </div>
        <div className="col-md-6">
            <button
                className="btn btn-sm btn-link pl-0 mr-0"
                onClick={handleBcLoad}
            >
                Refresh
            </button>
        </div>
        <div className="col-md-6 text-right">
            <a
                href="https://ows01.hireright.com/login/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-sm btn-link"
            >
                Link To Hire Right
            </a>
        </div>

        <div className="col-md-12">
            <div className="table-responsive">

                <table className="table table-bordered">
                    <thead className="thead-light">
                        <tr>
                            <th>S.No.</th>
                            <th>Date & Time</th>
                            <th>Background Check Name </th>
                            <th> Internal  Notes</th>
                            <th>Internal Documents</th>
                            <th>Status</th>
                            <th>Notify Candidate</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {backgroundChecks.map((item, key) => (
                            <tr>
                                <td>{key + 1}</td>
                                <td>
                                    <Moment format="MMM Do YYYY, h:mm a">
                                        {item.addedDateTime}
                                    </Moment>
                                </td>
                                <td>{item.name}</td>
                                <td>
                                    <button
                                        className="btn btn-link btn-sm p-0 text-underline"
                                        onClick={() => handleBcCheckShowHide(item, "edit")
                                        }
                                    >
                                        View/Edit
                                    </button>
                                </td>
                                <td className="p-2">
                                    {item.updatedDocList.map((doc) => (
                                        <React.Fragment>
                                            <li className="list-group-item p-1">
                                                <button
                                                    className="btn btn-link btn-sm p-0 text-underline"
                                                    onClick={() => handleDownloadFile(doc)}
                                                >
                                                    {doc.documentName}
                                                </button>
                                                <button
                                                    className="float-right mr-2 btn btn-sm"
                                                    onClick={() => handleDeleteTimeSheetDoc(item.id)}
                                                >
                                                    <i
                                                        className="fa fa-trash text-red"
                                                        aria-hidden="true"
                                                    ></i>
                                                </button>
                                            </li>
                                        </React.Fragment>
                                    ))}
                                    <br />
                                    {item.notes}
                                </td>
                                <td>
                                    {item.status === null && (
                                        <span>
                                            Pending
                                        </span>
                                    )}
                                    {item.status && (
                                        <span>
                                            Passed
                                        </span>
                                    )}

                                    {!item.status && item.status !== null && (
                                        <span>
                                            Failed
                                        </span>
                                    )}
                                    <br />
                                    {item.updatedDateTime !== null && (
                                        <Moment format="MMM Do YYYY, h:mm a">
                                            {item.updatedDateTime}
                                        </Moment>
                                    )}
                                </td>
                                <td>
                                    {!item.sendStatus && (
                                        <button
                                            className="btn btn-link btn-sm p-0 text-underline"
                                            onClick={() => handleBcCheckShowHide(item, "notify")}
                                        >
                                            Notify
                                        </button>
                                    )}
                                    {item.sendStatus && (
                                        <span>
                                            Notified
                                        </span>
                                    )}
                                    <br />
                                    {item.notifyDateTime !== null && (
                                        <Moment format="MMM Do YYYY, h:mm a">
                                            {item.notifyDateTime}
                                        </Moment>
                                    )}
                                    <br />
                                    {item.docList.map((doc) => (

                                        <li className="list-group-item p-1">
                                            <button
                                                className="btn btn-link btn-sm p-0 text-underline"
                                                onClick={() => handleDownloadFile(doc)}
                                            >
                                                {doc.documentName}
                                            </button>
                                        </li>
                                    ))}
                                    {item.docList.length > 0 && <br />}
                                    {item.instructionNotes}
                                </td>
                                <td>
                                    <button
                                        className="btn btn-link btn-sm p-0 text-underline"
                                        onClick={() => handleDeleteBcChecks(item.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
        {bcCheckShowHide &&
            <AddBcChecks
                bcCheckShowHide={bcCheckShowHide}
                handleBcCheckShowHide={handleBcCheckShowHide}
                candidateObj={candidateObj}
                workItem={subProccessTask}
                bcObject={bcObject}
                bcType={bcType}
                //selectedObj={selectedObj}
                workflowTask={subProccessTask}
                backgroundCheckApp={subProccessTask}
            ></AddBcChecks>}
    </>
}

export default BcChecks;
